import React, { Component, ReactElement } from 'react'
import { Translate } from 'react-localize-redux'
import { Input } from 'antd'
import { isString } from 'lodash-es'
import { IInputFieldProps } from '../../../shared/components/fields/Fields.interfaces'
import styles from '../../../shared/components/fields/Fields.module.scss'
import { fetchUsersList } from 'core/actions/Users.actions'
import { IActionCreatorAsync } from 'core/actions/Actions.interfaces'
import { connect } from 'react-redux'
import { IAppState } from 'core/store/store'
import { IUser } from 'reducers/Reducers.interfaces'
import { LIMIT_MAX } from 'core/utils/constants'

interface IUserDispatchProps {
  user: IUser
  fetchUsersList: IActionCreatorAsync
}
type TUserProps = IUserDispatchProps & IInputFieldProps
export class InputFieldUniqueValue extends Component<TUserProps, any> {
  constructor (props) {
    super(props)
    this.state = {
      user_name: this.props.user.user_name
    }
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange (event) {
    this.setState({ user_name: event.target.value })
    window.user_name = event.target.value
    this.props.fetchUsersList({ limit: LIMIT_MAX, offset: 0 }, { userName: event.target.value.trim() })
  }

  render (): ReactElement {
    const {
      label,
      labelPosition,
      input,
      placeholder,
      required,
      meta: { touched, error },
      ...rest
    } = this.props
    const isInlineDirection: boolean = labelPosition === 'inline'

    return (
      <div className={styles.inputWrap} style={{ display: this.props.type === 'hidden' ? 'none' : 'block' }}>
        {label &&
          <label className={isInlineDirection ? styles.inlineLabel : styles.inputLabel}>
            {isString(label)
              ? <Translate id={label} />
              : label.map(lb => <span key={lb}><Translate id={lb} />&nbsp;</span>)
            }{required ? <sup className={styles.required}>*</sup> : null}
          </label>
        }

        <Translate>
          {({ translate }) => (
            <Input
              {...input}
              {...rest}
              size='large'
              value={this.state.user_name}
              onChange={this.handleChange}
              placeholder={placeholder ? translate(placeholder) as string : ''}
              className={isInlineDirection ? styles.inlineInput : ''}
            />
          )}
        </Translate>

        {touched && ((error &&
          <label className={isInlineDirection ? styles.inlineErrorLabel : styles.errorLabel}>
            <Translate id={error} />
          </label>
        ))}
      </div>
    )
  }
}

export default connect((state: IAppState) => ({ users: state.users.items }),
  { fetchUsersList }
)(InputFieldUniqueValue)
